/**
 * Route for `real-time-dns-cname-propagation-without-48hr-wait`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeDnsCnamePropagationWithout48hrWaitPage } from "../features/real-time-dns-cname-propagation-without-48hr-wait/RealTimeDnsCnamePropagationWithout48hrWaitPage";

export const realTimeDnsCnamePropagationWithout48hrWaitRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-dns-cname-propagation-without-48hr-wait",
	component: RealTimeDnsCnamePropagationWithout48hrWaitPage,
});

export default realTimeDnsCnamePropagationWithout48hrWaitRoute;
